;(function () {
  'use strict'
  if (window.CHICCHOK_CART_PURCHASE_GUARD) return

  var scopeSelector = '[data-cc-purchase-scope]'
  var productId = '9757488021811'
  var state = null
  var pending = false
  var revision = -1
  var generation = 0
  var activeRead = null
  var observerRoots = new Set()
  var observer = new MutationObserver(render)

  function cartState(cart) {
    if (!cart || !Array.isArray(cart.items)) return null
    if (cart.items.some(function (line) {
      return !line || !Number.isFinite(Number(line.quantity)) || Number(line.quantity) < 0 ||
        Number(line.quantity) > 0 && !line.product_id
    })) return null
    var lines = cart.items.filter(function (line) { return Number(line.quantity) > 0 })
    if (!lines.length) return 'empty'
    return lines.every(function (line) { return String(line.product_id) === productId }) ? 'insurance-only' : 'ready'
  }

  // This module only owns the notice. Checkout validation belongs to CartGate.
  function render() {
    observer.disconnect()
    document.querySelectorAll(scopeSelector).forEach(function (scope) {
      var current = state || scope.getAttribute('data-cc-cart-state') || 'empty'
      scope.setAttribute('data-cc-cart-state', current)
      scope.querySelectorAll('[data-cc-purchase-message]').forEach(function (element) {
        element.hidden = current !== 'insurance-only'
      })
      observerRoots.add(scope.parentElement || scope)
    })
    observerRoots.forEach(function (root) {
      if (root.isConnected === false) observerRoots.delete(root)
      else observer.observe(root, { childList: true, subtree: true })
    })
  }

  function invalidate() {
    generation += 1
    if (activeRead) {
      window.clearTimeout(activeRead.timer)
      activeRead.controller.abort()
      activeRead = null
    }
  }

  function update(cart) {
    var next = cartState(cart)
    if (next === null) return cart
    invalidate()
    state = next
    render()
    return cart
  }

  async function refresh() {
    invalidate()
    if (pending) return
    var current = generation
    var request = { controller: new AbortController(), timer: null }
    activeRead = request
    request.timer = window.setTimeout(function () { request.controller.abort() }, 5000)
    try {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/'
      var response = await fetch(root.replace(/\/?$/, '/') + 'cart.js', {
        credentials: 'same-origin', cache: 'no-store', signal: request.controller.signal,
        headers: { Accept: 'application/json' },
      })
      if (!response.ok || current !== generation) return
      var cart = await response.json()
      if (current === generation) update(cart)
    } catch (error) {
      // A stale notice must never prevent a customer from checking out.
    } finally {
      window.clearTimeout(request.timer)
      if (current === generation) activeRead = null
    }
  }

  function acceptRevision(detail) {
    var next = detail.revision !== undefined ? detail.revision : detail.cartRevision
    if (typeof next !== 'number' || !Number.isFinite(next)) return true
    if (next < revision) return false
    revision = next
    return true
  }

  window.CHICCHOK_CART_PURCHASE_GUARD = {
    version: '2026-10-22-notice-only',
    update: update,
    assertPurchasable: update,
  }
  document.addEventListener('chicchok:cart-state', function (event) {
    var detail = event.detail || {}
    if (typeof detail.pending !== 'boolean' || !acceptRevision(detail)) return
    pending = detail.pending
    if (pending) invalidate()
    else refresh()
  })
  document.addEventListener('cart:updated', function (event) {
    var detail = event.detail || {}
    if (!acceptRevision(detail)) return
    if (detail.cart) update(detail.cart)
    else refresh()
  })
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh()
  })
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refresh()
  })
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render, { once: true })
  else render()
})()
